// The Tavern HUD: a DOM overlay with a grid toggle, zoom in/out,
// and a mode indicator. Sits above the Phaser canvas.
//
// All buttons emit events via `emit(name, detail)` so the scene can
// react without the HUD knowing Phaser.
//
// Keep it minimal: the Tavern is the stage, the HUD is the border.

const ICONS = {
  grid:     '<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z"/></svg>',
  zoomIn:   '<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path stroke-linecap="round" d="M21 21l-4.35-4.35M8 11h6M11 8v6"/></svg>',
  zoomOut:  '<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path stroke-linecap="round" d="M21 21l-4.35-4.35M8 11h6"/></svg>',
};

export class TavernHUD {
  constructor(root, { mode = "At the Tavern" } = {}) {
    this.root = root;
    this.listeners = new Map();
    this.gridOn = false;
    this.mount(mode);
  }

  mount(mode) {
    this.root.innerHTML = "";
    this.root.classList.remove("hidden");
    this.root.classList.add("tavern-hud");

    // Mode indicator (top-centre)
    this.modePill = document.createElement("div");
    this.modePill.className = "tavern-hud-mode";
    this.modePill.textContent = mode;
    this.root.appendChild(this.modePill);

    // Tool cluster (top-right under the exit pill)
    const tools = document.createElement("div");
    tools.className = "tavern-hud-tools";

    this.gridBtn = this.makeButton("Grid", ICONS.grid, () => {
      this.gridOn = !this.gridOn;
      this.gridBtn.classList.toggle("active", this.gridOn);
      this.emit("grid-toggle", { on: this.gridOn });
    });
    tools.appendChild(this.gridBtn);

    tools.appendChild(this.makeButton("Zoom in", ICONS.zoomIn, () => {
      this.emit("zoom", { delta: 0.2 });
    }));
    tools.appendChild(this.makeButton("Zoom out", ICONS.zoomOut, () => {
      this.emit("zoom", { delta: -0.2 });
    }));

    this.root.appendChild(tools);
  }

  makeButton(label, icon, onClick) {
    const btn = document.createElement("button");
    btn.className = "tavern-hud-btn";
    btn.title = label;
    btn.setAttribute("aria-label", label);
    btn.innerHTML = icon;
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      onClick();
    });
    return btn;
  }

  setMode(modeLabel) {
    this.modePill.textContent = modeLabel;
  }

  on(name, cb) {
    if (!this.listeners.has(name)) this.listeners.set(name, []);
    this.listeners.get(name).push(cb);
  }

  emit(name, detail) {
    const cbs = this.listeners.get(name) || [];
    for (const cb of cbs) cb(detail);
  }
}
